export default "__VITE_ASSET__D2W5z3jI__"